<script>
import LayerComponents from './popup';
const cache = [];
const ZINDEX_START_VALUE = 1000;
export default {
  name: 'PoupChild',
  props: {
    index: {
      type: Number,
      default: 0
    },
    layerName: {
      type: String,
      default: ''
    },
    keepAlive: {
      type: Boolean,
      default: false
    },
    layerData: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  render (h) {
    const name = this.layerName;
    const component = LayerComponents[name];
    const zIndex = this.index + (this.layerData.zIndex || 0);
    if (component) {
      if (this.keepAlive) {
        if (!cache[name]) {
          cache[name] = { component };
        }
        const cachedData = cache[name];
        const cachedComponent = cachedData && cachedData.component;
        return h(cachedComponent, { style: { 'z-index': ZINDEX_START_VALUE + zIndex }, props: this.layerData },[this.layerData.customSlot && h(this.layerData.customSlot,{props: this.layerData})]);
      }
      return h(component, {
        style: { 'z-index': ZINDEX_START_VALUE + zIndex },
        props: this.layerData,
        
      },[this.layerData.customSlot && h(this.layerData.customSlot,{props: this.layerData})]);
    }
    return h();
  }
};
</script>
<style scoped>
.poupContainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
</style>
